import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=448ff03d"
import script from "./leader.vue?vue&type=script&lang=js"
export * from "./leader.vue?vue&type=script&lang=js"
import style0 from "./leader.vue?vue&type=style&index=0&id=448ff03d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports